import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=2c872504&scoped=true&"
import script from "./foot.vue?vue&type=script&lang=js&"
export * from "./foot.vue?vue&type=script&lang=js&"
import style0 from "./foot.vue?vue&type=style&index=0&id=2c872504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c872504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c872504')) {
      api.createRecord('2c872504', component.options)
    } else {
      api.reload('2c872504', component.options)
    }
    module.hot.accept("./foot.vue?vue&type=template&id=2c872504&scoped=true&", function () {
      api.rerender('2c872504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/foot.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/foot.vue
// module id = 7y/R
// module chunks = 0